import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { PublicClientApplication } from '@azure/msal-browser'
import { config } from '../config/environment'
import { authApiService } from '../services/authApiService'
import { useAuth } from '../contexts/AuthContext'

export default function AuthRedirectPage() {
  const navigate = useNavigate()
  const { refresh } = useAuth()
  const handled = useRef(false)

  useEffect(() => {
    if (handled.current) return
    handled.current = true

    // const log = (msg: string) => console.log('[MSAL]', msg)
    // const err = (msg: string, e?: unknown) => console.error('[MSAL]', msg, e)

    // log(`href: ${window.location.href}`)
    // log(`hash: ${window.location.hash}`)
    // log(`search: ${window.location.search}`)

    if (!config.microsoftClientId) { navigate('/login'); return }

    const msal = new PublicClientApplication({
      auth: {
        clientId: config.microsoftClientId,
        redirectUri: window.location.origin + '/auth-redirect',
      },
    })

    const nav = navigate
    const ref = refresh

    msal.initialize().then(async () => {
      // log('initialized')
      try {
        const result = await msal.handleRedirectPromise({ navigateToLoginRequestUrl: false })
        // log(`handleRedirectPromise: account=${result?.account?.username ?? 'null'} idToken=${!!result?.idToken}`)
        if (!result?.account) {
          // log('no account in result, navigating to /login')
          nav('/login')
          return
        }
        msal.setActiveAccount(result.account)
        let idToken = result.idToken
        if (!idToken) {
          // log('idToken empty, trying acquireTokenSilent')
          const silent = await msal.acquireTokenSilent({
            scopes: ['openid', 'profile', 'email'],
            account: result.account,
          })
          idToken = silent.idToken
          // log(`acquireTokenSilent: idToken=${!!idToken}`)
        }
        if (!idToken) {
          // err('no idToken after silent')
          nav('/login?error=microsoft')
          return
        }
        // log('calling backend oauthMicrosoft')
        const signIn = await authApiService.oauthMicrosoft(idToken)
        if (signIn?.requiresMfa) { nav('/mfa'); return }
        // log('backend ok, refreshing')
        await ref()
        nav('/app/dashboard')
      } catch (e) {
        console.error('[MSAL] error:', e)
        nav('/login?error=microsoft')
      }
    }).catch(e => {
      console.error('[MSAL] initialize error:', e)
      nav('/login?error=microsoft')
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
